/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EntityNotFoundErrorDetailsErrorResponseModel,
  InvalidPropertyValueErrorDetailsErrorResponseModel,
  MessageResponseDto,
  SetPasswordDto,
  VerifyPasswordSetupTokenDto,
} from '../models/index';
import {
    EntityNotFoundErrorDetailsErrorResponseModelFromJSON,
    EntityNotFoundErrorDetailsErrorResponseModelToJSON,
    InvalidPropertyValueErrorDetailsErrorResponseModelFromJSON,
    InvalidPropertyValueErrorDetailsErrorResponseModelToJSON,
    MessageResponseDtoFromJSON,
    MessageResponseDtoToJSON,
    SetPasswordDtoFromJSON,
    SetPasswordDtoToJSON,
    VerifyPasswordSetupTokenDtoFromJSON,
    VerifyPasswordSetupTokenDtoToJSON,
} from '../models/index';

export interface AccountSetupSetPasswordPOSTRequest {
    setPasswordDto?: SetPasswordDto;
}

export interface AccountSetupVerifyTokenGETRequest {
    token?: string;
}

/**
 * AccountSetupApi - interface
 * 
 * @export
 * @interface AccountSetupApiInterface
 */
export interface AccountSetupApiInterface {
    /**
     * Creates request options for accountSetupSetPasswordPOST without sending the request
     * @param {SetPasswordDto} [setPasswordDto] 
     * @throws {RequiredError}
     * @memberof AccountSetupApiInterface
     */
    accountSetupSetPasswordPOSTRequestOpts(requestParameters: AccountSetupSetPasswordPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {SetPasswordDto} [setPasswordDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountSetupApiInterface
     */
    accountSetupSetPasswordPOSTRaw(requestParameters: AccountSetupSetPasswordPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MessageResponseDto>>;

    /**
     */
    accountSetupSetPasswordPOST(requestParameters: AccountSetupSetPasswordPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MessageResponseDto>;

    /**
     * Creates request options for accountSetupVerifyTokenGET without sending the request
     * @param {string} [token] 
     * @throws {RequiredError}
     * @memberof AccountSetupApiInterface
     */
    accountSetupVerifyTokenGETRequestOpts(requestParameters: AccountSetupVerifyTokenGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} [token] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountSetupApiInterface
     */
    accountSetupVerifyTokenGETRaw(requestParameters: AccountSetupVerifyTokenGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VerifyPasswordSetupTokenDto>>;

    /**
     */
    accountSetupVerifyTokenGET(requestParameters: AccountSetupVerifyTokenGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VerifyPasswordSetupTokenDto>;

}

/**
 * 
 */
export class AccountSetupApi extends runtime.BaseAPI implements AccountSetupApiInterface {

    /**
     * Creates request options for accountSetupSetPasswordPOST without sending the request
     */
    async accountSetupSetPasswordPOSTRequestOpts(requestParameters: AccountSetupSetPasswordPOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/AccountSetup/set-password`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetPasswordDtoToJSON(requestParameters['setPasswordDto']),
        };
    }

    /**
     */
    async accountSetupSetPasswordPOSTRaw(requestParameters: AccountSetupSetPasswordPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MessageResponseDto>> {
        const requestOptions = await this.accountSetupSetPasswordPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MessageResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async accountSetupSetPasswordPOST(requestParameters: AccountSetupSetPasswordPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MessageResponseDto> {
        const response = await this.accountSetupSetPasswordPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for accountSetupVerifyTokenGET without sending the request
     */
    async accountSetupVerifyTokenGETRequestOpts(requestParameters: AccountSetupVerifyTokenGETRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/AccountSetup/verify-token`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async accountSetupVerifyTokenGETRaw(requestParameters: AccountSetupVerifyTokenGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VerifyPasswordSetupTokenDto>> {
        const requestOptions = await this.accountSetupVerifyTokenGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VerifyPasswordSetupTokenDtoFromJSON(jsonValue));
    }

    /**
     */
    async accountSetupVerifyTokenGET(requestParameters: AccountSetupVerifyTokenGETRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VerifyPasswordSetupTokenDto> {
        const response = await this.accountSetupVerifyTokenGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
